import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { queryKeys } from 'shared/api/model';
import { Logger } from 'shared/lib/logger';

export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { queryKey } = queryKeys.auth.info;

  return useMutation({
    mutationFn: () =>
      fetch(import.meta.env.VITE_BACKEND_URL + '/api/web/auth/logout', {
        method: 'POST',
        credentials: 'include',
      }),
    onSuccess: () => {
      queryClient.setQueryData(queryKey, null);
      navigate({
        to: '/auth',
      });
    },
    onError: (err) => {
      Logger.error('Error during logout:', err);
    },
  });
};
